import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { UserService } from 'app/modules/sho_management_pro/user/services/user.service';
import { PermissionService } from 'app/services/permission.service';
import { of, switchMap } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const _authService: AuthService = inject(AuthService);
    const _userService: UserService = inject(UserService);
    const permissionService = inject(PermissionService);

    // Check the authentication status
    const checkAuthStatus = () => {
        return inject(AuthService)
            .check()
            .pipe(
                switchMap((authenticated) => {
                    // If the user is not authenticated...
                    if (!authenticated) {
                        // Redirect to the sign-in page with a redirectUrl param
                        const redirectURL =
                            state.url === '/sign-out'
                                ? ''
                                : `redirectURL=${state.url}`;
                        const urlTree = router.parseUrl(
                            `sign-in?${redirectURL}`
                        );

                        return of(urlTree);
                    }

                    // Allow the access
                    return of(true);
                })
            );
    };

    // Auth guard begginign
    if (permissionService.directAccess) {
        checkAuthStatus();
    } else {
        const token = localStorage.getItem('accessToken');

        // If user is available, save in user Service
        const loggedUser = _authService.user;
        // console.log(loggedUser)

        // If not token redirect to login page
        if (!token) {
            const redirectURL =
                state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;
            const urlTree = router.parseUrl(`sign-in?${redirectURL}`);
            return of(urlTree);
        }

        if (loggedUser) {
            try {
                _userService.user = JSON.parse(loggedUser);
            } catch (error) {
                console.error('Error parsing loggedUser:', error);
            }
        }

        checkAuthStatus();
    }
};
